import React from 'react';
import { Result } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

type AuthenticatingProps = {
  status: string;
};

const Authenticating: React.FC<AuthenticatingProps> = ({ status }) => (
    <Result
        status="info"
        icon={<LoadingOutlined />}
        title={status}
    />
);

export default Authenticating;